var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74.9604,
    cy: 74.9604,
    r: 74.4604,
    fill: "#EEEEEE",
    stroke: "#675D5D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_109_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.1749 41.0775C86.4809 38.8642 92.254 39.2658 97.8204 39.3427C102.154 39.3427 106.312 40.8553 110.347 42.4789C110.393 43.3164 110.469 44.9999 110.508 45.8458C109.122 45.521 107.751 45.1877 106.381 44.8459C99.015 42.7949 90.8451 42.7778 84.0231 46.8798C77.1014 50.7167 72.6222 58.3397 69.8583 66.1588C67.791 71.8843 67.9748 78.1655 66.742 84.1048C65.9687 87.9761 63.7254 91.1464 61.6045 94.2229C56.0763 92.4198 50.1653 90.685 44.4382 92.4027C35.5334 94.8553 28.5124 101.991 20.1741 105.896C22.1495 102.35 25.2274 99.8802 27.9608 97.1197C31.8428 93.1971 35.9774 89.5397 39.3617 85.0531C44.752 78.4471 49.1087 70.9098 54.2694 64.0903C61.6045 54.4081 70.3408 45.4777 81.1755 41.0768L81.1749 41.0775Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0197 46.8805C90.8417 42.7785 99.0116 42.7957 106.377 44.8466C104.241 46.5557 101.753 48.188 100.773 51.0679C97.8785 59.118 100.083 68.0313 98.1003 76.2776C97.1509 80.1916 95.7956 84.1311 93.3684 87.2076C89.7468 91.1729 85.5126 94.7278 80.4898 96.0352C74.7704 97.676 68.9282 95.7959 63.293 94.6166C62.8718 94.5226 62.0296 94.3175 61.6008 94.2235C63.7217 91.147 65.9653 87.9767 66.7384 84.1054C67.9711 78.1661 67.7874 71.8852 69.8547 66.1594C72.6186 58.34 77.098 50.7174 84.0197 46.8805Z",
    fill: "#C83540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4974 96.0348C85.5202 94.7274 89.7541 91.1723 93.376 87.2073C88.9887 94.5993 81.0104 98.2055 73.2773 98.4107C75.0766 102.273 76.2405 106.572 78.637 110.041C82.2203 112.315 87.113 109.742 90.5509 112.195C86.1408 112.485 81.7227 112.195 77.3126 112.246C75.3371 107.384 74.0816 102.051 71.371 97.616C68.7831 96.3 65.9425 95.7701 63.3008 94.6165C68.936 95.7958 74.7782 97.6759 80.4976 96.0351L80.4974 96.0348Z",
    fill: "#101010"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149.921,
    height: 149.921,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_109_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.3335,
    height: 73.0606,
    fill: "white",
    transform: "translate(20.1741 39.2651)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f5e87c505aa3ab32770a80dbf09a6eba.svg";
export { ForwardRef as ReactComponent };